import { Socket } from 'socket.io-client';
import { ensureFreshAccessToken, refreshAccessToken } from './accessTokenRefresh';

export const isSocketAuthError = (message: string): boolean => (
  /token expired|jwt expired|authentication error/i.test(message || '')
);

export const bindSocketTokenRefresh = (socket: Socket) => {
  socket.io.on('reconnect_attempt', () => {
    const token = localStorage.getItem('accessToken');
    if (token) socket.auth = { token };
  });

  socket.on('connect_error', async (err) => {
    if (!isSocketAuthError(err.message || '')) return;
    const next = await refreshAccessToken();
    if (!next) return;
    socket.auth = { token: next };
    if (!socket.connected) socket.connect();
  });
};

export const tokenForSocket = async (fallback?: string | null): Promise<string | null> => (
  await ensureFreshAccessToken() || localStorage.getItem('accessToken') || fallback || null
);
